import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FaEyeSlash, FaRegEye } from 'react-icons/fa';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import { useToggle } from 'utils/hooks/useToggle';

import './FormComponents.scss';
import '../../../../views/Surveys/surveys.scss';

const TextInput = ({ validate, longmessage, label, gif, name, control, isRequired, ...rest }) => {
  const {
    formikProps: { errors },
  } = rest;
  const isBlockType = control === 'block';
  const isPassword = control === 'password';
  const TYPES = { text: 'text', numeric: 'number', password: 'password' };

  const [displayPassword, setDisplayPassword] = useToggle(false);

  return (
    <div className="question">
      <div>
        <label htmlFor={name}>{label}</label>
      </div>
      {!!gif && (
        <div className="question__gif">
          <LazyLoadImage effect="opacity" src={gif} alt="this is a Gif" />
        </div>
      )}
      <Field
        {...rest}
        max={9999999999}
        type={displayPassword ? 'text' : TYPES[control] || 'text'}
        id={name}
        name={name}
        className={`input ${isBlockType ? 'field-block' : ''}`}
      />
      {isPassword && (
        <div className="question__validation_eyeicon eyeicon">
          {displayPassword ? <FaRegEye onClick={setDisplayPassword} /> : <FaEyeSlash onClick={setDisplayPassword} />}
        </div>
      )}
      {validate && errors[name] && (
        <span className={`question__validation_error labelerror ${longmessage ? 'long' : ''}`}>{errors[name]}</span>
      )}
    </div>
  );
};

TextInput.defaultProps = {
  gif: '',
  validate: false,
  longmessage: false,
  isRequired: false,
  label: '',
};

TextInput.propTypes = {
  label: PropTypes.string,
  gif: PropTypes.string,
  validate: PropTypes.bool,
  longmessage: PropTypes.bool,
  name: PropTypes.string.isRequired,
  control: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
};

export default TextInput;
